import { createI18n } from "vue-i18n";
import Cookie from "js-cookie";
import enGB from "./locales/en-GB.json";
import zhCN from "./locales/zh-CN.json";

const LANGUAGE_KEY = "language";
const DEFAULT_LANGUAGE = "en-GB";
export type AvailableLanguages = "en-GB" | "zh-CN";

// 获取浏览器语言并匹配支持的语言
const getBrowserLanguage = (): AvailableLanguages => {
  const browserLang = navigator.language.toLowerCase();

  // 如果浏览器语言以zh开头（如zh-CN, zh-TW等），返回简体中文
  if (browserLang.startsWith("zh")) {
    return "zh-CN";
  }

  // 其他语言默认使用英语
  return DEFAULT_LANGUAGE;
};

// 优先使用Cookie中保存的语言，如果不存在则使用浏览器语言
const currentLanguage = Cookie.get(LANGUAGE_KEY) || getBrowserLanguage();

export const i18n = createI18n({
  legacy: false,
  locale: currentLanguage,
  fallbackLocale: DEFAULT_LANGUAGE,
  messages: {
    "en-GB": enGB,
    "zh-CN": zhCN,
  },
});

// 修改语言并存储至 Cookie
// Cookie 配置：
// - expires: 365天后过期
// - path: 设置为根路径，确保在所有页面都能访问
export const setLanguage = (lang: AvailableLanguages) => {
  i18n.global.locale.value = lang;
  Cookie.set(LANGUAGE_KEY, lang, {
    expires: 365, // 设置 Cookie 365天后过期
    path: "/", // 设置 Cookie 在根路径下可用
  });
  document.querySelector("html")?.setAttribute("lang", lang);
};
